export default __webpack_public_path__ + "static/media/File_Converter_1_resized.8d580632.png";